import { FilledButton } from 'components/Custom/FilledButton'
import { Box, Typography } from 'components/Material/index'
import { SidebarFooter } from 'components/Custom/SidebarFooter'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useIsMobile } from 'hooks/useIsResponsive'
import { deleteSuportMaterialById, getDocumentoById } from 'services/documentos/material-apoio'
import { useEffect, useState } from 'react'
import useTextStyles from 'styles/useTextStyles'
import { SidebarBox } from '../SidebarBox'
import { ErrorResponse, HandlerErrorMessage } from 'utils/HandlerErrorMessage'
import { DeleteDocumentApprovalParams } from 'types/material-apoio'
import { AxiosError } from 'axios'
import RenderImage, {
  FileExtension,
  downloadBase64File,
  mountTextUserDate,
  renderDefaultIcon
} from 'utils/fileFunction'
import useUserInfoStore from 'store/useUser'
import { CustomPdfViewer } from '../CustomPdfViewer'
import { useSnackbarAlertContext } from 'contexts/SnackbarContext'
import ContainerImage from '../ContainerImages'
import { DocumentViewerParams } from '.'

export const DocumentViewerBody = ({
  exibitionName,
  id_corcc080,
  tipoArquivo,
  onClosed,
  queryToInvalidate
}: DocumentViewerParams) => {
  const isMobile = useIsMobile()
  const [editedText, setEditedText] = useState('')
  const fileTypeLowerCase = tipoArquivo.toLowerCase()
  const { privilegios } = useUserInfoStore((state) => state)
  const { showAlert } = useSnackbarAlertContext()
  const [filename, setFilename] = useState('')
  const [id_corcc132, setId_corcc132] = useState(0)
  const queryClient = useQueryClient()

  const getDocumentoByIdMutation = useMutation({
    mutationFn: getDocumentoById,
    onSuccess: (data) => {
      const userAlter = data?.nm_usuario_alteracao || data?.nm_usuario_inclusao || ''
      const dateAlter = data?.dh_inclusao
      const id_coorc132 = data?.id_corcc132
      const filename = data?.doc_digitalizado.nm_arquivo || ''
      setFilename(filename)
      setId_corcc132(id_coorc132)

      setEditedText(mountTextUserDate(userAlter, dateAlter))
    },
    onError: (error: AxiosError<ErrorResponse>) => {
      HandlerErrorMessage({ error, showAlert })
      onClosed()
    }
  })
  useEffect(() => {
    getDocumentoByIdMutation.mutate(id_corcc080)
  }, [id_corcc080])

  const { data: file, isPending: isLoading } = getDocumentoByIdMutation

  const deleteSuportMaterialByIdMutation = useMutation<
    unknown,
    AxiosError<ErrorResponse>,
    DeleteDocumentApprovalParams
  >({
    mutationFn: deleteSuportMaterialById,
    onError: (error: AxiosError<ErrorResponse>) => {
      HandlerErrorMessage({ error, showAlert })
    }
  })
  const handleDeleteSuportMaterialById = () => {
    deleteSuportMaterialByIdMutation.mutate(
      { id_corcc132, id_corcc080 },
      {
        onSuccess: () => {
          showAlert({ message: 'Documento excluído com sucesso', statusType: 'success' })
          queryClient.refetchQueries({ queryKey: [queryToInvalidate] })
          onClosed()
        }
      }
    )
  }

  return (
    <ContainerImage
      leftText={exibitionName}
      onRightIconClick={() => onClosed()}
      isPageLoading={!file || isLoading}
    >
      <Box className="flex w-full flex-col justify-center items-center gap-5 p-5 flex-grow ">
        <SidebarBox>
          <Typography align="center" sx={{ ...useTextStyles.titleSmall }}>
            {editedText}
          </Typography>
        </SidebarBox>
        <Box className={` justify-center items-center  w-full h-full max-w-[800px] flex-grow`}>
          {fileTypeLowerCase === 'pdf' && (
            <CustomPdfViewer file={file?.doc_digitalizado?.documento} />
          )}
          {(fileTypeLowerCase === 'png' || fileTypeLowerCase === 'jpg') && (
            <RenderImage
              base64Data={file?.doc_digitalizado?.documento || ''}
              type={fileTypeLowerCase}
              isMobile={isMobile}
            />
          )}
          {fileTypeLowerCase !== 'pdf' &&
            fileTypeLowerCase !== 'png' &&
            fileTypeLowerCase !== 'jpg' &&
            renderDefaultIcon(isMobile)}
        </Box>
      </Box>
      <SidebarFooter
        className={`!w-full !max-w-none fixed bottom-0 ${isMobile ? ' bg-[#f4f4f6]' : 'bg-[#000]'}`}
      >
        <Box className="w-full flex justify-center gap-5 flex-wrap">
          <FilledButton
            onClick={handleDeleteSuportMaterialById}
            form="tertiary"
            loading={deleteSuportMaterialByIdMutation.isPending}
            disabled={
              !file?.doc_digitalizado?.documento || privilegios.sn_material_apoio_exclui === 'N'
            }
          >
            Excluir
          </FilledButton>
          <FilledButton
            onClick={() =>
              downloadBase64File({
                file: file?.doc_digitalizado?.documento || '',
                extension: fileTypeLowerCase as FileExtension,
                name: filename
              })
            }
            disabled={
              !file?.doc_digitalizado?.documento || privilegios.sn_material_apoio_relatorio === 'N'
            }
          >
            Download
          </FilledButton>
        </Box>
      </SidebarFooter>
    </ContainerImage>
  )
}
